// Auth Endpoints
export const LOGIN_API = "/en/api/jwt/email-login/";
export const LOGOUT_API = "/en/api/jwt/logout/";
export const REFRESH_API = "/en/api/jwt/refresh/";
export const REGISTER_API = "/en/api/inactive-register/";
export const VERIFY_EMAIL_API = "/en/api/web-verify-email";
export const REQUEST_PASSWORD_RESET_API = "/en/auth/request-password-reset/";
export const RESET_PASSWORD_API = "/en/auth/reset-password/";

// Public pages content endpoints
export const HOME_PAGE_CONTENT_API = "/en/api/cms/homepage/";
export const ABOUT_PAGE_CONTENT_API = "/en/api/cms/aboutpage/";
export const FEATURES_PAGE_CONTENT_API = "/en/api/cms/featurespage/";
export const BLOG_API = "/en/api/cms/blogs/";

// Schools Endpoints
export const COUNTRIES_API = "/en/api/nursery/countries";
export const PROGRAMTYPES_API = "/en/api/nursery/program-types/";
